import { useEffect, useRef, useState } from "react";
import ThumbnailSecondmentItem from "../thumbnailItem/thumbnailSecondmentItem";
import { ThumbnailContainerProps } from "./thumbnailContainer.props";
import { ThumbNailProductsContainer } from "./thumbnailContainer.styled";

const SecondmentsThumbnailContainer: React.FC<ThumbnailContainerProps> = ({
  // setShow,
  bodyContent,
  data,
  isService,
  onchangeService,
  isShowLogo,
}) => {
  const [width, setWidth] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const sortedData = data?.slice().sort((a, b) => {
    const serviceA = a.title?.toLowerCase() || "";
    const serviceB = b.title?.toLowerCase() || "";
    const titleA = a.mainServiceName?.toLowerCase() || "";
    const titleB = b.mainServiceName?.toLowerCase() || "";
    const regionA = a.regionName?.toLowerCase() || "";
    const regionB = b.regionName?.toLowerCase() || "";
  
    if (serviceA !== serviceB) {
      return serviceA.localeCompare(serviceB);
    } else if (titleA !== titleB) {
      return titleA.localeCompare(titleB);
    } else {
      return regionA.localeCompare(regionB);
    }
  });
  
  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [data]);
  return (
    <>
      {data && data!.length > 0 ? (
        <ThumbNailProductsContainer ref={containerRef} className="mr-[-10px]">
          {sortedData?.map((item, index) => (
            <ThumbnailSecondmentItem
              key={index} // Use a unique key, such as `item.id`, if available
              isShowLogo={isShowLogo}
              bodyContent={bodyContent}
              data={item}
              isService={isService}
              buttonText="View"
              onchangeSelectedService={(e) => {
                onchangeService(e);
              }}
              buttonTextClassName="serviceBtnItem"
              width={Number(width) / 3 - 20}
            />
          ))}
        </ThumbNailProductsContainer>
      ) : null}
    </>
  );
};

export default SecondmentsThumbnailContainer;
